export const isClient = typeof window !== 'undefined'
export const isServer = !isClient
export const isTouchDevice = isClient && 'ontouchstart' in window

export const hasPopoverSupport = typeof document !== 'undefined' && 'showPopover' in document.body

// We can only enable native dialogs if the browser also supports popovers.
// Otherwise stacking in top layer would not work if a popover is nested in a dialog.
export const hasDialogSupport = hasPopoverSupport
// typeof window !== 'undefined' && 'HTMLDialogElement' in window;
